import { FC, useMemo } from "react";
import { theme } from "@repo/ui";
import {
  AudienceContext,
  AudienceContextType,
  createAudiencePaths,
} from "@repo/contexts";
import { getUserAudience } from "@repo/utils";
import { CssBaseline, ThemeProvider } from "@mui/material";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Login from "@/Login";
import RedirectToInstitution from "@/components/RedirectToInstitution";
import LogOut from "@/LogOut";
import { Routes as ROUTES } from "@/constants";

interface LocaleContextProps {
  children: React.ReactNode;
}
const LocaleContext: FC<LocaleContextProps> = ({ children }) => {
  const { pathname } = useLocation();
  const audienceInfo = useMemo(() => getUserAudience(pathname), [pathname]);

  const audienceContextValue: AudienceContextType = useMemo(
    () => ({
      ...audienceInfo,
      paths: createAudiencePaths(audienceInfo),
    }),
    [audienceInfo],
  );

  return (
    <AudienceContext.Provider value={audienceContextValue}>
      {children}
    </AudienceContext.Provider>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <LocaleContext>
          <Routes>
            <Route element={<RedirectToInstitution />}>
              <Route element={<Login />} path={ROUTES.LOGIN_EUA} />
              <Route element={<Login />} path={ROUTES.LOGIN_NA} />
              <Route element={<LogOut />} path={ROUTES.LOGOUT_EUA} />
              <Route element={<LogOut />} path={ROUTES.LOGOUT_NA} />
            </Route>
          </Routes>
        </LocaleContext>
      </Router>
    </ThemeProvider>
  );
}

export default App;
